import {
  BuildProvisioningActions,
  BuildProvisioningReducerState,
  FETCH_BUILD_PROVISIONING_FILES,
  FETCH_BUILD_PROVISIONING_FILES_IS_ERROR,
  FETCH_BUILD_PROVISIONING_FILES_IS_PENDING,
  FETCH_BUILD_PROVISIONING_REGISTRATION,
  FETCH_BUILD_PROVISIONING_REGISTRATION_IS_ERROR,
  FETCH_BUILD_PROVISIONING_REGISTRATION_IS_PENDING,
  RESET_BUILD_PROVISIONING_REGISTRATION,
} from 'services/GameHosting/BuildProvisioning/types';
import { parseError, sort } from 'utils/functions';

const INITIAL_STATE = {
  buildProvisioningRegistration: [],
  buildProvisioningRegistrationIsCompleted: false,
  buildProvisioningRegistrationIsPending: false,
  buildProvisioningRegistrationIsError: null,

  buildProvisioningFiles: [],
  buildProvisioningFilesIsCompleted: false,
  buildProvisioningFilesIsPending: false,
  buildProvisioningFilesIsError: null,
} satisfies BuildProvisioningReducerState;

const buildProvisioningReducer = (
  previousState: BuildProvisioningReducerState | undefined,
  action: BuildProvisioningActions,
): BuildProvisioningReducerState => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_BUILD_PROVISIONING_REGISTRATION:
      return {
        ...state,
        buildProvisioningRegistration: sort(action.data ?? [], {
          sortBy: 'name',
          sortDirection: 'ASC',
        }),
        buildProvisioningRegistrationIsCompleted: true,
        buildProvisioningRegistrationIsPending: false,
        buildProvisioningRegistrationIsError: null,
      };
    case FETCH_BUILD_PROVISIONING_REGISTRATION_IS_PENDING:
      return {
        ...state,
        buildProvisioningRegistrationIsCompleted: false,
        buildProvisioningRegistrationIsPending: true,
        buildProvisioningRegistrationIsError: null,
      };
    case FETCH_BUILD_PROVISIONING_REGISTRATION_IS_ERROR:
      return {
        ...state,
        buildProvisioningRegistrationIsCompleted: true,
        buildProvisioningRegistrationIsPending: false,
        buildProvisioningRegistrationIsError:
          action.error && typeof action.error === 'object' && 'message' in action.error ? parseError(action.error.message) : action.error,
      };

    case FETCH_BUILD_PROVISIONING_FILES:
      return {
        ...state,
        buildProvisioningFiles: sort(action.data ?? [], {
          sortBy: 'fileName',
          sortDirection: 'ASC',
        }),
        buildProvisioningFilesIsCompleted: true,
        buildProvisioningFilesIsPending: false,
        buildProvisioningFilesIsError: null,
      };
    case FETCH_BUILD_PROVISIONING_FILES_IS_PENDING:
      return {
        ...state,
        buildProvisioningFilesIsCompleted: false,
        buildProvisioningFilesIsPending: true,
        buildProvisioningFilesIsError: null,
      };
    case FETCH_BUILD_PROVISIONING_FILES_IS_ERROR:
      return {
        ...state,
        buildProvisioningFilesIsCompleted: false,
        buildProvisioningFilesIsPending: false,
        buildProvisioningFilesIsError:
          action.error && typeof action.error === 'object' && 'message' in action.error ? parseError(action.error.message) : action.error,
      };

    case RESET_BUILD_PROVISIONING_REGISTRATION:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default buildProvisioningReducer;
